import { render, staticRenderFns } from "./TransportadoraTpCalcDetalhes.vue?vue&type=template&id=7de99684"
import script from "./TransportadoraTpCalcDetalhes.vue?vue&type=script&lang=js"
export * from "./TransportadoraTpCalcDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports